import ru from './ru/index.js'
import en from './en/index.js'
import kk from './kk/index.js'
import uzb from './uz/index.js'
import uk from './uk/index.js'
import az from './az/index.js'
import ky from './ky/index.js'
import bn from './bn/index.js'

export default {
  en: en,
  ru: ru,
  kk: kk,
  uz: uzb,
  uk: uk,
  az: az,
  ky: ky,
  bn: bn,
}
